<template>
  <div>
    <!-- 筛选区域 -->
    <el-form :model="formInline" inline size="small" class="filter-form">
      <el-form-item label="时间范围">
        <el-date-picker
          v-model="formInline.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          style="width: 250px;"
        />
      </el-form-item>
      <!-- <el-form-item label="商品分类">
        <el-select v-model="formInline.category" placeholder="选择分类" clearable style="width: 150px;">
          <el-option
            v-for="item in categoryList"
            :key="item.category_id"
            :label="item.category_name"
            :value="item.category_id"
          />
        </el-select>
      </el-form-item> -->
      <el-form-item label="仓库区域">
        <el-cascader
            v-model="formInline.warehouse"
            :options="warehouseList"
            :props="{ value: 'warehouse_kw_id', label: 'name', children: 'children' }"
            placeholder="选择区域"
            clearable
            style="width: 250px;"
          />
      </el-form-item>
      <el-form-item label="损耗类型">
        <el-select v-model="formInline.type" placeholder="选择类型" clearable style="width: 150px;">
          <el-option label="报损" :value="1" />
          <el-option label="报溢" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        <el-button @click="resetFilters">重置</el-button>
      </el-form-item>
      <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="onExport">导出</el-button>
               
            </el-form-item>
    </el-form>

    <!-- 数据表格 -->
    <el-table :data="tableData" border style="width: 100%;" v-loading="loading">
      <el-table-column prop="productName" label="商品名称"  />
      <el-table-column prop="productSpecification" label="规格"  />
      <el-table-column prop="productCategory" label="分类" width="120" />
      <el-table-column prop="warehousekwtext" label="仓库区域" width="120" />

      <el-table-column prop="purchasePrice" label="进货价"   />
          <el-table-column prop="product_price" label="销售价"    />
           
      <el-table-column prop="act_num" label="实际库存"  />
      <el-table-column prop="actual_price" label="线下实际进货价">
      </el-table-column>
      <el-table-column prop="difference" label="差异数量" />
      <el-table-column prop="difference_price" label="差异金额"></el-table-column>
            
      <el-table-column prop="rk_stock" label="入库库存"  />
      <el-table-column prop="ck_stock" label="出库库存"  />
      <el-table-column prop="type" label="类型" >
        <template #default="scope">
          <span v-if="scope.row.type === 1 && scope.row.difference != 0" style="color: red;">库存报损</span>
          <span v-else-if="scope.row.type === 2 && scope.row.difference != 0" style="color: green;">库存报溢</span>
        </template>
      </el-table-column>
      <el-table-column prop="price_type" label="类型" >
        <template #default="scope">
          <span v-if="scope.row.price_type === 1 && scope.row.difference_price != 0" style="color: red;">金额报损</span>
          <span v-else-if="scope.row.price_type === 2 && scope.row.difference_price != 0" style="color: green;">金额报溢</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" />
      <el-table-column prop="create_time" label="记录时间" />
    </el-table>

    <!-- 分页 -->
    <div class="pagination">
          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background :current-page="curPage"
          :page-sizes="[20, 100,500, 1000]"
          layout="total,sizes, prev, pager, next, jumper"
          :total="totalDataNumber"></el-pagination>
     </div>

    <!-- 数据统计 -->
    <div class="statistics">
      <el-card>
        <div slot="header">统计信息</div>
        <div>总报损数量：{{ statistics.total_loss }}</div>
        <div>总报溢数量：{{ statistics.total_overage }}</div>
        <div>总报损金额：{{ statistics.total_loss_price }}</div>
        <div>总报溢金额：{{ statistics.total_overage_price }}</div>
        <div>总记录数：{{ statistics.total_records }}</div>
      </el-card>
    </div>
  </div>
</template>
  
  <script>
      import ReportApi from '@/api/report.js';
      import WarehouseApi from '@/api/warehouse.js';
         import qs from 'qs'
  export default {
    components: {

    },
    data() {
      return {
          /*是否加载完成*/
          loading: false,
        formInline: {
        dateRange: [],
        category: null,
        warehouse: null,
        type: null,
      },
      tableData: [],
      loading: false,
      categoryList: [], // 商品分类列表
      warehouseList: [], // 仓库区域列表
      statistics: {
        total_loss: 0,
        total_overage: 0,
        total_records: 0,
      },
           /*一页多少条*/
           pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
       
      };
    },
    created() {
      this.getWarehouse();
      this.getTableList()
    },
  
    methods: {
      onExport: function() {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/report/exportLoss?' + qs.stringify(this.formInline);
      },
       /*搜索查询*/
       onSubmit() {
        let self = this
        self.tableData = [];
        self.curPage = 1
        self.getTableList();
      },
         // 重置筛选条件
      resetFilters() {
        this.formInline = {
          dateRange: [],
          category: null,
          warehouse: null,
          type: null,
        };
        this.curPage = 1;
        this.getTableList();
      },
      handleSelectionChange(e) {
        this.multipleSelection = e;
      },
       /*选择第几页*/
       handleCurrentChange(val) {
        this.curPage = val
        this.getTableList()
      },
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1
        this.pageSize = val
        this.getTableList()
      },
      getTableList(){
        let self = this;
        const params = {
            start_date: this.formInline.dateRange[0],
            end_date: this.formInline.dateRange[1],
            // category_id: this.formInline.category,
            warehouse_kw_id: this.formInline.warehouse,
            type: this.formInline.type,
            page: self.curPage,
            pageSize:  self.pageSize,
          };
        ReportApi.getLossStatisticssalestable(params)
            .then((data) => {
              self.loading = false;
              self.tableData = data.data.list.data;
              self.totalDataNumber =  data.data.list.total
              self.statistics = data.data.statistics
            })
            .catch((error) => {});
    },
         /*获取列表*/
         getWarehouse() {
          let self = this;
          WarehouseApi.list({}, true)
            .then(data => {
      
              self.warehouseList = data.data.list.data;

            })
            .catch(error => {
            });
      },
  
    }
  };
  </script>
  <style></style>
  


// WEBPACK FOOTER //
// src/views/report/loss.vue